import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import {
  ROUTE_FREE_TRIAL,
  ROUTE_FREE_TRIAL_B,
  ROUTE_SIGN_IN,
  ROUTE_SUBSCRIBE,
  ROUTE_WELCOME_ONBOARD,
} from "./lib/constants.ts";

import RouteDecider from "./containers/RouteDecider.tsx";
import Analytics from "./containers/Analytics.tsx";
import Home from "./pages/Home/Home.tsx";
import SignIn from "./pages/Signin/SignIn.tsx";
import FreeTrialStripeWrapper from "./pages/FreeTrial/FreeTrialStripeWrapper.tsx";
import WelcomeOnboard from "./pages/WelcomeOnboard/WelcomeOnboard.tsx";
import PaymentInfoProvider from "./providers/PaymentInfoProvider.tsx";
import SubscriptionProvider from "./providers/SusbscriptionProvider.tsx";
import AuthProvider from "./providers/AuthProvider.tsx";

function App() {
  return (
    <Router>
      <AuthProvider>
        <SubscriptionProvider>
          <PaymentInfoProvider>
            <RouteDecider />
            <Analytics />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path={ROUTE_SIGN_IN} element={<SignIn />} />
              <Route
                path={ROUTE_FREE_TRIAL}
                element={<FreeTrialStripeWrapper freeTrialActive />}
              />
              <Route
                path={ROUTE_SUBSCRIBE}
                element={<FreeTrialStripeWrapper />}
              />
              {/* Multiplan variant: the 3-plan picker. The redirect decider
                  only sends trial-eligible multiplan users here. */}
              <Route
                path={ROUTE_FREE_TRIAL_B}
                element={<FreeTrialStripeWrapper freeTrialActive multiplan />}
              />
              <Route
                path={ROUTE_WELCOME_ONBOARD}
                element={<WelcomeOnboard />}
              />
            </Routes>
          </PaymentInfoProvider>
        </SubscriptionProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
